import { render } from "./BlackjackCard.vue?vue&type=template&id=8f901354&scoped=true"
import script from "./BlackjackCard.vue?vue&type=script&lang=js"
export * from "./BlackjackCard.vue?vue&type=script&lang=js"

import "./BlackjackCard.vue?vue&type=style&index=0&id=8f901354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f901354"]])

export default __exports__